export class AutoIncrement{constructor(){this.counter=1;this.nextKey=()=>this.counter++}}